import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const uptimerobot = defineConnector({
  identifier: "uptimerobot",
  name: "UptimeRobot",
  tagLine: "Website monitoring service",
  logo,
  protocol: "http",
  tags: ["observability", "it"],
  defaultUrlPattern: () => "https://api\\.uptimerobot\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [UptimeRobot](https://dashboard.uptimerobot.com/integrations), navigate to **My Settings > API Settings**, and copy your main API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.uptimerobot.com/v2/getAccountDetails",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    }),
  },
});
